// modules
import type { CredentialCardKey, CredentialCardValue, MenuItemProps, ResultError } from 'modules';

// libraries
import { atom, selector } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import AxiosInstanceCreator from 'services/api';

export const { persistAtom } = recoilPersist({
  key: 'fadhili-recoil-persist',
  storage: localStorage,
  converter: JSON
});

export const initialState = {
  pkgNo: null,
  menuList: [],
  currentMenu: null,
  credentialCard: {
    visa: { number: '', expiryDate: '' },
    passport: { number: '', expiryDate: '' },
    cidb: { number: '', expiryDate: '' },
    ogsp: { number: '', expiryDate: '' },
    medical: { number: '', expiryDate: '' },
    psac: { number: '', expiryDate: '' }
  }
};

/** PKG No */
export const PkgNoAtom = atom<string | null>({
  key: 'PkgNoAtom',
  default: initialState.pkgNo,
  effects_UNSTABLE: [persistAtom]
});

/** CI */
export const CiAtom = atom<string | null>({
  key: 'CiAtom',
  default: null
});

/** CI Selector */
export const CiSelectorAtom = selector<any>({
  key: 'CiSelectorAtom',
  get: async ({ get }) => {
    const pkgNo = get(PkgNoAtom);

    if (!pkgNo) return null;

    try {
      const axios = new AxiosInstanceCreator().create();
      const res = await axios.get('/img/ci').then((res) => res.data);
      console.log('== res == : ', res);
      return res;
    } catch (error) {
      const err = error as ResultError;
      console.log('== err == : ', err.message);
      return null; // 오류 시 기본값 반환
    }
  }
});

/** 메뉴 리스트 */
export const MenuListAtom = atom<MenuItemProps[]>({
  key: 'MenuListAtom',
  default: initialState.menuList,
  effects_UNSTABLE: [persistAtom]
});

/** 현재 메뉴 */
export const CurrentMenuAtom = atom<MenuItemProps | null>({
  key: 'CurrentMenuAtom',
  default: initialState.currentMenu,
  effects_UNSTABLE: [persistAtom]
});

/** 자격증 카드 */
export const CredentialCardAtom = atom<Record<CredentialCardKey, CredentialCardValue>>({
  key: 'CredentialCardAtom',
  default: initialState.credentialCard
});
